import { Box, Grid, Typography } from "@mui/material";
import FeedbackPublicUrl from "../customerAdmin/components/feedback/FeedbackPublicUrl";

const CustomerFeedbackUrl = () => {
  return (
    <>
     <Box
      sx={{
        background: "linear-gradient(135deg, #e0f7fa 0%, #e8f5e9 100%)",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 2,
      }}
    >
      <Grid
        container
        justifyContent="center"
        sx={{
          background: "#ffffff",
          borderRadius: "16px",
          boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
          padding: { xs: 2, md: 4 },
          width: "100%",
          // maxWidth: "900px",
        }}
      >
       <Grid item xs={12}>
         <Typography
            variant="h4"
            align="center"
            sx={{
              fontWeight: 700,
              mb: 1,
              color: "#2E7D32",
            }}
          >
            Customer Feedback
          </Typography>

          <FeedbackPublicUrl />
        </Grid>
      </Grid>
      </Box>
    </>
  );
};

export default CustomerFeedbackUrl;
